import { render, staticRenderFns } from "./LoaderSplash.vue?vue&type=template&id=550bfa80&scoped=true&"
import script from "./LoaderSplash.vue?vue&type=script&lang=js&"
export * from "./LoaderSplash.vue?vue&type=script&lang=js&"
import style0 from "./LoaderSplash.vue?vue&type=style&index=0&id=550bfa80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550bfa80",
  null
  
)

export default component.exports